// src/pages/Query.tsx
//
// The /query route, kept for direct links and bookmarks.
//
// The query form itself is not here. It lives in components/Query/QueryForm and
// is rendered identically inside QueryModal, so there is exactly one
// implementation of the validation and the email call. This page is only the
// frame around it, for the case where someone arrives on /query directly rather
// than opening the window from somewhere in the site.
//
// If this route is ever retired, delete this file and its <Route> in App.tsx —
// nothing else depends on it.
import styled from 'styled-components';

import Footer from '../components/Footer';
import QueryForm from '../components/Query/QueryForm';

const Page = styled.main`
  width: 90%;
  max-width: 640px;
  margin: 3rem auto 0;
  padding: 2rem 1.5rem;
  background: ${({ theme }) => theme.surface};
  border: ${({ theme }) => theme.cardBorder};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.lg};

  @media (max-width: 480px) {
    margin-top: 1.5rem;
    padding: 1.25rem 1rem;
  }
`;

/**
 * The heading lives here rather than inside QueryForm, because the modal already
 * has a title bar saying the same thing. On this page there is no window, so the
 * page has to supply it.
 */
const Title = styled.h1`
  margin: 0 0 0.5rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.headingColor};

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

const Query = () => (
  <>
    <Page>
      <Title>Submit Your Query</Title>
      {/*
        No onSuccess. Previously this page redirected to "/" once the success
        message ran out, which threw away the visitor's place; on a dedicated
        form page the natural end of a send is to stay on it with the form
        cleared. The success message still appears and still dismisses itself.
      */}
      <QueryForm />
    </Page>
    <Footer />
  </>
);

export default Query;
